import { render, staticRenderFns } from "./Amanare.vue?vue&type=template&id=4d3514c4&"
import script from "./Amanare.vue?vue&type=script&lang=js&"
export * from "./Amanare.vue?vue&type=script&lang=js&"
import style0 from "./Amanare.vue?vue&type=style&index=0&id=4d3514c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
